import { useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { MapMode } from "../context/MapContext";
import { useRouter } from "next/router";

export const useMapMode = (): MapMode => {
  const searchParams = useSearchParams();
  return searchParams.get("mode") as MapMode;
};

export const useUpdateMapMode = () => {
  const router = useRouter();

  return useCallback(
    (mode: MapMode | undefined) => {
      if (router.isReady) {
        router.query.mode = mode;
        router.push({ pathname: router.pathname, query: router.query });
      }
    },
    [router],
  );
};

export const getSurveyOpen = (router) => {
  const searchParams = { ...router.query };
  const surveyOpen = searchParams["survey"];
  delete searchParams.survey;
  router.replace({ pathname: router.pathname, query: searchParams });

  return surveyOpen !== undefined;
};
